import ImageViewer from "@shared/ui/hook-form/image-control/image-viewer/image-viewer";
import "./child-info.scss";
import TextBlock from "@shared/ui/text-block/text-block";
import { calculateAge } from "@shared/utility/calculage-age";
import classNames from "classnames";
import { FaChild } from "react-icons/fa";

export interface ChildInfoProps {
  name: string;
  birthday?: string;
  photo?: string;
  className?: string;
  onRemove?: () => void;
}

export function ChildInfo({
  name,
  birthday,
  photo,
  className,
  onRemove,
}: ChildInfoProps) {
  const age = birthday ? calculateAge(birthday).toString() : null;

  return (
    <div
      id="ChildInfo"
      className={classNames(
        "child-info border p-4 rounded-lg flex items-center gap-2 relative pr-8",
        className
      )}
    >
      {photo ? (
        <ImageViewer image={photo} className="w-11 h-11 rounded-full" />
      ) : (
        <span className="border rounded-full p-3">
          <FaChild />
        </span>
      )}
      <div className="flex flex-col">
        <span className="font-bold">{name}</span>
        {age ? <TextBlock label="Age" value={age} /> : null}
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-gray-100 transition-colors flex items-center justify-center cursor-pointer border-0 bg-transparent"
          title="Remove"
        >
          <i className="pi pi-times text-xs" />
        </button>
      )}
    </div>
  );
}

export default ChildInfo;
